import { render, staticRenderFns } from "./work_list.vue?vue&type=template&id=681d7f28&scoped=true"
import script from "./work_list.vue?vue&type=script&lang=js"
export * from "./work_list.vue?vue&type=script&lang=js"
import style0 from "./work_list.vue?vue&type=style&index=0&id=681d7f28&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681d7f28",
  null
  
)

export default component.exports